// angular import
import { Component, OnDestroy, OnInit } from '@angular/core';

// project import
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { HORIZONTAL, VERTICAL, COMPACT, RTL } from 'src/app/@theme/const';
import { ChangeBranchComponent } from 'src/app/tabms/components/admin/change-branch/change-branch.component';
import { MatDialog } from '@angular/material/dialog';
import { ChangePaySlipComponent } from 'src/app/tabms/components/admin/change-pay-slip/change-pay-slip.component';
import { AccountService } from 'src/app/tabms/services/admin/account/account.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { Subject, takeUntil } from 'rxjs';
import { ApiSessionService } from 'src/app/tabms/services/global/api-session.service';
import { TabUserPaySlipService } from 'src/app/tabms/services/admin/tab-user-pay-slip/tab-user-pay-slip.service';

@Component({
  selector: 'app-nav-left',
  templateUrl: './toolbar-left.component.html',
  styleUrls: ['./toolbar-left.component.scss']
})
export class NavLeftComponent implements OnInit, OnDestroy {
  showToggleMenu: boolean = true;
  showBranchIcon: boolean = true;
  showPaySlipIcon: boolean = false;
  session;

  private destroy: Subject<void> = new Subject<void>();

  // constructor
  constructor(
    private layoutService: ThemeLayoutService,
    public dialog: MatDialog,
    private accountService: AccountService,
    private SessionService: SessionWrapperService,
    private baseService: BaseService,
    private tabUserpaySlipService: TabUserPaySlipService,
    private apiSessionService: ApiSessionService
  ) { }

  ngOnInit() {
    //first initialization
    this.layoutService.layout.pipe(takeUntil(this.destroy)).subscribe((res) => {
      // console.log(res)
      if (res === VERTICAL) {
        this.showToggleMenu = true;
      }
      if (res == HORIZONTAL) {
        this.showToggleMenu = false;
      }
    });


    this.session = this.SessionService.getsessionData();
    this.checkBranch();
    this.checkPaySlip();
  }

  // public method
  toggleMenu() {
    this.layoutService.toggleSideDrawer();
  }

  changeBranch() {
    this.dialog.open(ChangeBranchComponent, {
      width: '400px',
      direction: this.baseService.getDirection()
    });
  }

  changePaySlib() {
    this.dialog.open(ChangePaySlipComponent, {
      width: '400px',
      height: '300px',
      direction: this.baseService.getDirection()
    });
  }

  checkBranch() {
    //check user branches to show or hide change branch icon
    this.accountService.GetBranchesByUser(this.session.userid).pipe(takeUntil(this.destroy)).subscribe((res) => {
      if (res) {
        if (res.result?.length <= 1) this.showBranchIcon = false;
      }
    });
  }

  checkPaySlip() {
    let sysCode = this.SessionService.getSysCode();
    if (sysCode == '11') {
      // 11 => 'HR'
      //check user pay slips to show or hide change pay slip icon
      this.tabUserpaySlipService.GetPaySlipsByUser(this.session.userid).pipe(takeUntil(this.destroy)).subscribe((res) => {
        if (res) {
          // debugger
          console.log("Pay slips", res);
          
          if (res.result?.length > 1) this.showPaySlipIcon = true;
          let defaultPaySlip = res?.result?.find((x) => x.defaultpayslip == true);
          this.SessionService.setDefaultPaySlip(defaultPaySlip);
          this.apiSessionService.changeUserCurrentPaySlip(defaultPaySlip.payslipid); //set default pay slip
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
